import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'subpage.breatheBubble.heading',
		defaultMessage: 'Try a quick breathing exercise to ease your stress.',
		description: 'Heading for the breathe bubble section',
	},
});
